import { render, staticRenderFns } from "./pastLives.vue?vue&type=template&id=cf84c090&"
import script from "./pastLives.vue?vue&type=script&lang=js&"
export * from "./pastLives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports